import { createSelector } from 'reselect';

export const getUsers = (state) => state?.user?.users;

export const selectUsers = createSelector([getUsers], (users) => {
  return users?.map((user) => ({
    ...user,
    key: user?.username,
    group: (user?.groups || [])[0],
  }));
});
